import { colors, sizes } from '../theme/tokens.js'

// The one chosen look on the booking screen: wash cards, car size, day
// chips, time slots and extras. Robin, 12 Oct 2026, of four options: "im
// thinking b ? if we can fix the javascript? think its better branding?".
// So the wash cards' green (tint, border, tick) everywhere. The 11 Oct
// accent fill is gone (DESIGN.md §10).
//
// What Robin had felt on 11 Oct was the delay, not the look: a 150ms colour
// fade, and makeStyles inside a render rebuilding every JSS sheet on each
// tap. Both stay fixed: no colour transition here (the press is a quick
// scale, which moves no layout), and every user calls makeStyles once per
// module.
//
// Lives outside theme/ on purpose: the brand green is not a token.
export const GREEN = '#37b45a'
export const GREEN_TINT = '#f0faf3'

// Spread `choice` into the button's class and `choiceOn` into the class it
// gets when chosen, AFTER it in the same sheet. Unchosen: white, a 1px
// --line border, ink text. Chosen: the green tint, a 2px green border drawn
// as the 1px border plus a 1px inset ring (nothing moves by a pixel), ink
// text. `&&` doubles the class so the chosen look also beats hover.
export const choice = {
  position: 'relative',
  minHeight: sizes.tapMin,
  border: `1px solid ${colors.line}`,
  boxShadow: 'none',
  background: colors.paper,
  color: colors.ink,
  cursor: 'pointer',
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  transition: 'transform 80ms ease-out',
  '@media (hover: hover)': {
    '&:hover': { borderColor: colors.mute, background: colors.paper }
  },
  '&:active': { transform: 'scale(0.97)', borderColor: GREEN }
}

export const choiceOn = {
  '&&': {
    borderColor: GREEN,
    boxShadow: `inset 0 0 0 1px ${GREEN}`,
    background: GREEN_TINT,
    color: colors.ink
  }
}
